import { createSlice } from '@reduxjs/toolkit';
import { processOfflineMutations, syncOfflineMutation } from '../middleware/offline-mutations.thunk';
import type { RootState } from '../store';

interface OfflineSyncState {
  isSyncing: boolean;
}

const initialState: OfflineSyncState = {
  isSyncing: false,
};

const offlineSyncSlice = createSlice({
  name: 'offlineSync',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(processOfflineMutations.pending, (state) => {
        state.isSyncing = true;
      })
      .addCase(processOfflineMutations.fulfilled, (state) => {
        state.isSyncing = false;
      })
      .addCase(processOfflineMutations.rejected, (state) => {
        state.isSyncing = false;
      })
      .addCase(syncOfflineMutation.pending, (state) => {
        state.isSyncing = true;
      })
      .addCase(syncOfflineMutation.fulfilled, (state) => {
        state.isSyncing = false;
      })
      .addCase(syncOfflineMutation.rejected, (state) => {
        state.isSyncing = false;
      });
  },
});

export const selectIsSyncing = (state: RootState) => state.offlineSync.isSyncing;

export default offlineSyncSlice.reducer;
